import { render, staticRenderFns } from "./TokenAmount.vue?vue&type=template&id=8d7d2fe8&"
import script from "./TokenAmount.vue?vue&type=script&lang=js&"
export * from "./TokenAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports